import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-early-checkin-popup',
  templateUrl: './early-checkin-popup.component.html',
  styleUrls: ['./early-checkin-popup.component.scss'],
})
export class EarlyCheckinPopupComponent implements OnInit {

  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() buttons: any;
  @Input() small: any;
  @Input() email: any;
  @Input() description: any;
  constructor(
    public modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  close(){
    this.modalCtrl.dismiss({data: true});
  }
}
